module.exports = __webpack_public_path__ + "static/bg-sec5-2-5c267580f1fb10529e099fa795f0c24a.jpg";